import { useMemo } from 'react';

import { filterByFreeText as defaultFilterByFreeText } from '../client-side';
import { FreeTextPredicate } from '../types';

type UseSearchByFreeTextArgs = {
  data?: any[];
  freeText?: string;
  enabled?: boolean;
  freeTextPredicate?: FreeTextPredicate;
  filterByFreeText?: (
    data: any[],
    freeText: string,
    freeTextPredicate?: FreeTextPredicate
  ) => any[];
};

export const useSearchByFreeText = ({
  data,
  freeText,
  enabled = true,
  freeTextPredicate,
  filterByFreeText = defaultFilterByFreeText,
}: UseSearchByFreeTextArgs) => {
  return useMemo(() => {
    if (!enabled) {
      return data;
    }
    if (!data?.length) {
      return [];
    }
    if (!freeText) {
      return data;
    }
    return filterByFreeText(data, freeText, freeTextPredicate);
  }, [data, freeText, enabled, freeTextPredicate, filterByFreeText]);
};
